<template>
    <el-dialog class="common-dialog type1"
               :title="title"
               :visible.sync="visibleModel"
               :center="true">
        <div class="content">
            <slot></slot>
            <el-button type="primary" @click="confirm()">{{btnText}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: ['visible', 'title', 'btnText', 'content'],
        data() {
            return {}
        },
        computed: {
            visibleModel: {
                get() {
                    return this.visible;
                },
                set(val) {
                    this.$emit('update:visible', val);
                }
            }
        },
        methods: {
            confirm() {
                this.$emit('confirm');
                this.visibleModel = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        font-size: 20px;
        text-align: center;
        .el-button {
            position: absolute;
            left: 50%;
            bottom: 42px;
            width: 220px;
            height: 60px;
            font-size: 21px;
            color: #fff;
            margin-left: -110px;
        }
    }
</style>
<style lang="scss">
    .common-dialog.type1 {
        .el-dialog {
            width: 600px;
            height: 250px;
        }
        .el-dialog__header {
            padding: 42px 0 0;
            text-align: center;
            &::after {
                display: none;
            }
        }
        .el-dialog__title {
            font-size: 20px;
        }
        .el-dialog__body {
            position: relative;
            height: 184px;
            padding: 15px 1.25rem;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// app/components/DialogOperate.vue